import React, {
  useMemo,
  useReducer
} from 'react';
import { node } from 'prop-types';
import ABTestsReducer from '../../reducers/ABTestsReducer/ABTestsReducer';
import { getABTests } from '../../utils/abTests';
import ABTestsContext from '../../contexts/ABTestsContext/ABTestsContext';

export const ABTestsProvider = ({ children }) => {
  const initialABTests = getABTests();

  // Store the current AB config in state.
  const [abTests, setABTests] = useReducer(
    ABTestsReducer,
    initialABTests
  );

  // You should use useMemo to memoize the values returned to the Context Provider.
  // It reduces context consumers from re-rendering if no changes occur.
  const ABTestsContextValue = useMemo(() => ({
    abTests,
    setABTests
  }), [abTests]);

  return (
    <ABTestsContext.Provider value={ABTestsContextValue}>{children}</ABTestsContext.Provider>
  );
};

ABTestsProvider.propTypes = {
  children: node.isRequired
};

ABTestsProvider.defaultProps = {};

export default ABTestsProvider;
